<!--
 * @Descripttion:
 * @version:
 * @Author: sueRimn
 * @Date: 2021-02-03 10:50:09
 * @LastEditors: sueRimn
 * @LastEditTime: 2021-02-03 11:35:56
-->
<template>
  <div class="personalCenter">
    <div class="personalCenter_head">
      <div class="personalCenter_user">
        {{publicPage.phone}}

        <span @click="onUpdatePhone" v-if="publicPage.personAuthStatus">变更</span>
      </div>
      <div class="personalCenter_state" @click="goRealNameAuth">{{ publicPage.personAuthStatus ? '已认证' : '未认证' }}</div>
    </div>
    <List :authStatus="publicPage.personAuthStatus" :phone="publicPage.phone"></List>
    <span class="contact_info">联系我们：400-8512366转9</span>

    <UpdatePhone ref="UpdatePhone" :submit="submit" :goFace="goFace"></UpdatePhone>

    <UpdatePhone2 ref="UpdatePhone2"></UpdatePhone2>

    <FloatingWindow></FloatingWindow>
  </div>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex';
import FloatingWindow from '@/components/FloatingWindow.vue';

import List from './components/index.vue';
import UpdatePhone from './components/UpdatePhone'
import UpdatePhone2 from './components/UpdatePhone2'
import { Toast } from 'vant';

export default {
  name: 'personalCenter',
  data() {
    return {
    };
  },
  components: {
    List,
    FloatingWindow,
    UpdatePhone,
    UpdatePhone2
  },
  computed: {
    ...mapState({
      publicPage(val) {
        return val.publicPage;
      },
    }),
  },
  mounted() {
    this.getUserInfo();
    if(!!this.$route.query.updatePhoneVerify){
      this.$refs.UpdatePhone2.showPopup = !!this.$route.query.updatePhoneVerify
      this.$router.replace({})
    }
  },
  methods: {
    ...mapMutations('publicPage', ['updateState']),
    ...mapActions('publicPage', ['getUserInfo']),
    goRealNameAuth() {
      if (this.publicPage.personAuthStatus) {
        this.$router.push('/supermarket/v2/realNameAuth');
      } else {
        this.$router.push('/supermarket/v2/realName');
      }
    },
    goFace(){
      this.$router.push('/supermarket/v2/faceRecognitionV3');
    },
    submit() {
      this.$refs.UpdatePhone2.showPopup = true
    },
    onUpdatePhone() {
      this.$api.PublicPage.hasOrderDoingByUserId({ userId: this.publicPage.userId }).then(res => {
        if (res.success) {
          this.$refs.UpdatePhone.showPopup = true
        } else {
          Toast(res.returnMessage);
        }
      })

    }
  },
};
</script>
<style scoped lang="scss">
.personalCenter_head {
  height: 94px;
  background: #ff6538;
  color: #fff;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  padding-left: 16px;
  margin-bottom: 16px;
}
.personalCenter_user {
  font-family: PingFangSC-Regular;
  font-size: 15px;
  span {
    border-bottom: 1px solid #fff;
  }
}
.personalCenter_state {
  font-size: 12px;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 2px;
  padding: 2px 7px;
  margin-top: 10px;
}
.contact_info {
  display: block;
  width: 100%;
  text-align: center;
  font-family: PingFangSC-Regular;
  font-size: 12px;
  color: #b8c4cc;
  letter-spacing: 0;
  position: absolute;
  bottom: 10px;
  left: 0;
}
</style>
